export default (percentage) => {
    let html = '<div class="rating">';
    html += `<div class="star-ratings-top" style="width:${percentage}%"><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span><span>&#9733;</span></div>`;
    html += '<div class="star-ratings-bottom"><span>&#9734;</span><span>&#9734;</span><span>&#9734;</span><span>&#9734;</span><span>&#9734;</span></div></div>';

    return html;
};